import DealsList from './DealsList';

export default DealsList;
